import { Component, OnInit, TemplateRef } from '@angular/core';
import { VentaService } from '../../../services/venta.service';
import { FelectronicaService } from '../../../services/felectronica.service';
import { Venta } from './../../../models/venta';
import { Router } from '@angular/router';
import { AsyncLocalStorage } from 'angular-async-local-storage';
import { SweetMessage } from '../../../config/sweet-message';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { VentaModalComponent } from '../../../components/modals/venta-modal/venta-modal.component';
import { FacturaModalComponent } from '../../../components/modals/factura-modal/factura-modal.component';
import { ReenviarCorreoComponent } from '../../../components/modals/reenviar-correo/reenviar-correo.component';
import { ConfirmacionAnulacionModalComponent } from '../../../components/modals/confirmacion-anulacion-modal/confirmacion-anulacion-modal.component';
import { SessionService } from '../../../services/session.service';
import { ReporteModalComponent } from '../../../components/modals/reporte-modal/reporte-modal.component';
import { ConfigService } from '../../../config/config-service';
import * as numeral from 'numeral';
import * as moment from 'moment';
import { ParametroService } from '../../../services/parametro.service';
import { environment } from '../../../../environments/environment';
import { AsientoContableDetalleModalComponent } from '../../modals/asiento-contable-modal/asiento-contable-detalle-modal.component';

@Component({
  selector: 'venta-list',
  templateUrl: './venta-list.component.html',
  styleUrls: ['./venta-list.component.css'],
  providers: [ VentaService, FelectronicaService, ParametroService]
})
export class VentaListComponent implements OnInit {
	public title: String;
	public ventas: Array<Venta> = [];
	public msg: SweetMessage;
	public bsModalRef: BsModalRef;
	public bsModalRef2: BsModalRef;
	public loading = false;
	public config: ConfigService;
	public venta_anulada: Venta;
	public observacion: String;
	public total: number;
	public total_activas: number;
	public total_anuladas: number;
	public Mod_FactElec: string;
	public Mod_Cartera: string;
	//public numero_decimales: number;
    //public format_decimal: String;
	public factelec_api: String;
	public Mod_Contabilidad: string;

	constructor(
		public VentaService: VentaService,
		public felectronicaService: FelectronicaService,
		private NavRoute: Router,
		private storage: AsyncLocalStorage,
		private modalService: BsModalService,
		private ss: SessionService,
		private parametroService: ParametroService,
	) {
		this.title = "Ventas";
		this.config = new ConfigService();
		this.venta_anulada = new Venta();
		this.observacion = "";
		this.Mod_FactElec = this.ss.getData("mod_felectronica");
		this.Mod_Cartera = this.ss.getData("mod_cartera");
		//this.numero_decimales = 2;
		//this.format_decimal = "0,0.00";
		this.factelec_api = environment.factelec_api;
		this.Mod_Contabilidad = this.ss.getData("mod_contabilidad");
	}

	ngOnInit() {
		this.msg = new SweetMessage();
		this.loading = true;

		//let p1 = this.getParamNumeroDecimales();
		let p2 = this.getVentas();

		Promise.all([p2]).then(
			res => this.loading = false,
			err => this.loading = false
		);
	}

	getVentas(){
		return new Promise((resolve, reject) => {
			let today = moment().format("YYYY-MM-DD");

			// let tipo_comprobante_id = "";
			// if(this.Mod_FactElec){
			// 	tipo_comprobante_id = "4";
			// }
			// else{
			// 	tipo_comprobante_id = "1";
			// }

			//&tipo_comprobante_id="+ tipo_comprobante_id +"
			this.VentaService.getAll("?fecha_emision=" + today + "&embed=tipocomprobante,asientocontable,estadobitacora,cliente&sort=-fecha_emision,-secuencial&usuario_id="+this.ss.getData('usuario_id')).subscribe(
				res => {
					this.ventas = res.data;
					this.total = 0;
					this.total_anuladas = 0;
					this.total_activas = 0;
					this.ventas.forEach(x => {
						this.total += parseFloat(x.total.toString());

						if( x.status === 'I' ) this.total_anuladas += parseFloat(x.total.toString());
						if( x.status === 'A' ) this.total_activas += parseFloat(x.total.toString());
					});
					resolve();
				},
				err => {
					this.ventas = [];
					reject(err);
				}
			);
		});
	}

	showModal(){
	}

	onEdit(venta) {
		this.storage.setItem("venta", venta).subscribe(() => {
			this.NavRoute.navigate(['/ventas/ventas-edit']);
		});
	}

	onShow(id){
		const initialState = {venta_id: id};
		this.bsModalRef = this.modalService.show(VentaModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));
	}
	onShowAsiento(asiento){
		const initialState = {asiento_id: asiento.id, tipo_transaccion_contabilidad_id: asiento.tipo_transaccion_contabilidad_id};
		this.bsModalRef = this.modalService.show(AsientoContableDetalleModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));
  	}


	onPrint(id){
		const initialState = {venta_id: id};
		this.bsModalRef = this.modalService.show(FacturaModalComponent, Object.assign({}, {class: '', initialState}));
	}

	onCbtFactElect(id){
        const initialState = {route: "cbt/factelect/" + id, qs: "?dbname=" + this.ss.getData('dbname') + "&factid=" + this.ss.getData('fact_id') + "&facttk=" + this.ss.getData('fact-api-token')};
		this.bsModalRef = this.modalService.show(ReporteModalComponent, Object.assign({}, {class: '', initialState}));
    }

	numeroFactura(venta){
        return venta.serie + "-" + venta.punto_emision + "-" + venta.secuencial;
	}
	
	parseTipo(tipo){
		if( tipo === "CR" ){
			return "Crédito";
		}else{
			return "Contado";
		}
	}

	onStatusElectronica(venta){
		let msn = "";
		msn += "<p>Estado de Factura Electrónica</p>";
        msn += "<p><b style='font-size:24px;'>"+venta.estadobitacora.descripcion+"</b></p>";
    
        this.msg.showMessage('single-message', msn);
	}

	OnReenviar1(venta, btn: HTMLInputElement){
		this.msg.showMessage('delete-confirm-message',"Está seguro de reenviar el correo al cliente: <br /> <b>" + venta.cliente.nombre_comercial + "</b><br> <b>" + venta.cliente.correo + "</b>").then(
			res => {
				if(res == "ok"){
					//venta.enviando = true;
					btn.disabled = true;
					btn.innerHTML = "<i class='fa fa-refresh fa-spin'></i>";

					let data = {
						"clave": venta.numero_autorizacion,
						"correo": venta.cliente.correo,
						"usuario_id": this.ss.getData('facelect_usuario_id')
					};
					this.felectronicaService.ReenviarElectronica(data).subscribe(
						() => {
							//venta.enviando = false;
							btn.disabled = false;
							btn.innerHTML = "<i class='fa fa-envelope'></i>";
						},
						() => {
							//venta.enviando = false;
							btn.disabled = false;
							btn.innerHTML = "<i class='fa fa-envelope'></i>";
						}
					);
				}
			}
		);
	}

	OnReenviar(venta: Venta){
        const initialState = { nombre: venta.cliente.nombre_comercial, correo: venta.cliente.correo, autorizacion: venta.numero_autorizacion };
		this.bsModalRef = this.modalService.show(ReenviarCorreoComponent, Object.assign({}, {initialState}));
    }

	onReport(venta){
		if(this.CodEst(venta) === 'btn-success'){
			const initialState = {host_api: this.factelec_api, route: "/" + this.ss.getData('fact_user') + "/ride/" + venta.numero_autorizacion, qs: "?tk=" + this.ss.getData('fact-api-token')};
			this.bsModalRef = this.modalService.show(ReporteModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));
		}
	}

	/*onXML(venta){
		if(this.CodEst(venta) === 'btn-success'){
			const initialState = {host_api: this.config.factelec_api, route: "/" + this.ss.getData('fact_user') + "/xml/" + venta.numero_autorizacion, qs: "?tk=" + this.ss.getData('fact-api-token')};
			this.bsModalRef = this.modalService.show(ReporteModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));
		}
	}*/

	setHrefXML(clave_Acceso){
		return this.factelec_api + "/" + this.ss.getData('fact_user') + "/xml/" + clave_Acceso + "?tk=" + this.ss.getData('fact-api-token');
	}

	onCbt(ventaId){
        const initialState = {route: "cbtventa/" + ventaId, qs: "?dbname=" + this.ss.getData('dbname') + "&factid=" + this.ss.getData('fact_id') + "&facttk=" + this.ss.getData('fact-api-token')};
		this.bsModalRef = this.modalService.show(ReporteModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));
    }

	CodEst(venta){
		let cod_ests = ['NAT', 'NFIR', 'NLOG', 'DEV', 'TOT', 'FEC'];
		let result = cod_ests.filter(cod_est => cod_est === venta.cod_est);

		if( result.length > 0 ){
			return 'btn-danger';
		}

		cod_ests = ['VAL', 'PPR', 'EP'];
		result = cod_ests.filter(cod_est => cod_est === venta.cod_est);

		if( result.length > 0 ){
			return 'btn-warning';
		}

		cod_ests = ['AUT'];
		result = cod_ests.filter(cod_est => cod_est === venta.cod_est);

		if( result.length > 0 ){
			return 'btn-success';
		}
	}

	isAnulable(venta: Venta){
		return true;

        /*let f = moment();
        let fecha = f.format("YYYY") + "-" + f.format("MM") + "-01";
        let fecha_inicio = moment(fecha,"YYYY-MM_DD").format('YYYY-MM-DD');
        let fecha_fin = moment().endOf('month').format('YYYY-MM-DD');
        let fecha_emision = moment(venta.fecha_emision.toString(),"YYYY-MM_DD");

        return fecha_emision.isSameOrAfter(fecha_inicio) && fecha_emision.isSameOrBefore(fecha_fin)*/
    }

	openModalObservacion(template: TemplateRef<any>, venta: Venta) {
		if( venta.status === 'A' && this.isAnulable(venta) ){
			if(venta.tipo_comprobante_id.toString() === "4"){
				let preg = "Recuerda que para anular algún comprobante primero debes anularlo desde <a href='https://declaraciones.sri.gob.ec/tuportal-internet/' target='_blank'>https://declaraciones.sri.gob.ec/tuportal-internet/</a>, posteriormente podrás anularlo desde esta opción. ¿Estás seguro que deseas continuar?";
				const initialState = { Pregunta: preg, Respuesta:false };
				this.bsModalRef = this.modalService.show(ConfirmacionAnulacionModalComponent, Object.assign({}, {initialState}));
				
				this.bsModalRef.content.action.take(1).subscribe((Respuesta) => {
					if(Respuesta == true){
						this.observacion = venta.observacion;
						this.venta_anulada = venta;
						this.bsModalRef = this.modalService.show(template);
						this.bsModalRef2 = this.bsModalRef;
					}
				});
			}else{
				this.observacion = venta.observacion;
				this.venta_anulada = venta;
				this.bsModalRef = this.modalService.show(template);
				this.bsModalRef2 = this.bsModalRef;
			}
		}
	}

	anularVenta(){
		this.bsModalRef2.hide();
		let preg = "¿Está seguro de querer anular el documento?";
		const initialState = { Pregunta: preg, Respuesta:false };
		this.bsModalRef = this.modalService.show(ConfirmacionAnulacionModalComponent, Object.assign({}, {initialState}));

		this.bsModalRef.content.action.take(1).subscribe((Respuesta) => {
			if(Respuesta == true){
				this.venta_anulada.observacion = this.observacion.toString().trim();
				this.venta_anulada.usuario_id = this.ss.getData("usuario_id");
				this.observacion  = "";
				
				this.loading = true;

				this.VentaService.anular(this.venta_anulada).subscribe(
					res => {
						this.bsModalRef.hide();
						this.venta_anulada = new Venta();

						this.msg.showMessage('success-message', 'Se ha procesado correctamente');

						this.getVentas().then(
							res => {
								this.loading = false;
							},
							err => {
								this.loading = false;
							}
						);
					},
					err => {
						this.loading = false;
					}
				);
			}
			else{
				return;
			}
		});
	}

	/*getParamNumeroDecimales(){
        return new Promise((resolve, reject) => {
            let numero_decimales = 19;
            this.parametroService.getById(numero_decimales).subscribe(
                res => {
                    this.numero_decimales = res.valor;

                    let digitos = "";
                    for(let i = 0; i < this.numero_decimales; i++) digitos += "0";
                    this.format_decimal = "0,0." + digitos
                    resolve();
                },
                err => {
                    this.numero_decimales = 2;
                    this.format_decimal = "0,0.00"
                    reject(err);
                }
            );
        });
	}
	
	get formatDecimal(){
        return this.format_decimal;
    }*/
}




// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/ventas/venta-list/venta-list.component.ts